var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "groupRulesEdit"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('span', [_c('strong', [_vm._v("Als...")])]), _c('ol', {
    staticClass: "px-4 pt-4 mb-2"
  }, _vm._l(_vm.rules, function (rule, index) {
    return _c('li', {
      key: `group-rule-${index}`,
      staticClass: "group-rule"
    }, [_c('b-row', [_c('b-col', {
      staticClass: "d-flex flex-row col-12 align-items-center justify-content-between",
      attrs: {
        "cols": "12"
      }
    }, [_c('span', [_c('GroupRuleEdit', {
      attrs: {
        "rule": rule,
        "index": index,
        "editing": _vm.isRuleBeingEdited(rule.id)
      }
    }), index !== _vm.rules.length - 1 ? _c('span', [_vm._v(", en...")]) : _vm._e()], 1), _c('span', {
      staticClass: "icons"
    }, [_c('b-button-group', [!_vm.isRuleBeingEdited(rule.id) ? _c('b-button', {
      staticClass: "bg-transparent text-primary border-0 p-2",
      on: {
        "click": function ($event) {
          _vm.rulesBeingEdited = rule.id;
        }
      }
    }, [_c('i', {
      staticClass: "far fa-pencil"
    })]) : _vm._e(), _c('b-button', {
      staticClass: "bg-transparent text-danger border-0 p-2",
      on: {
        "click": function ($event) {
          return _vm.removeRule(rule);
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-trash"
    })])], 1)], 1)]), _c('b-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('hr')])], 1)], 1);
  }), 0), _c('b-row', [_c('b-col', {
    staticClass: "d-flex col-12 align-items-center justify-content-between mb-4 pr-5",
    attrs: {
      "cols": "12"
    }
  }, [_c('span', [_c('strong', [_vm._v("...dan wordt de order op hold gezet. ")])]), _c('b-button', {
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.createRule
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  }), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v("Nieuwe regel toevoegen")])])], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }